export const OPTIMISTIC_SCAN_KEY_FIELD = '__scanKey';
export const OPTIMISTIC_SCAN_STATUS_FIELD = '__scanStatus';
export const OPTIMISTIC_SCAN_ERROR_FIELD = '__scanError';
export const OPTIMISTIC_SCAN_GENERATION_FIELD = '__scanGeneration';

export const OPTIMISTIC_SCAN_STATUS = {
	PENDING: 'pending',
	ADDED: 'added',
	ERROR: 'error',
};

export const getOptimisticScanStatus = row =>
	row?.[OPTIMISTIC_SCAN_STATUS_FIELD] ?? row?.scanStatus;

export const isOptimisticScanRow = row => Boolean(getOptimisticScanStatus(row));

export const isOptimisticScanPending = row =>
	getOptimisticScanStatus(row) === OPTIMISTIC_SCAN_STATUS.PENDING;

export const isOptimisticScanAdded = row =>
	getOptimisticScanStatus(row) === OPTIMISTIC_SCAN_STATUS.ADDED;

export const isOptimisticScanError = row =>
	getOptimisticScanStatus(row) === OPTIMISTIC_SCAN_STATUS.ERROR;

export const getOptimisticScanError = row =>
	row?.[OPTIMISTIC_SCAN_ERROR_FIELD] ?? row?.scanError;
